import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "highlightType", "alert", "links", "icon", "isDismissed", "isDismissible", "onDismiss", "inline", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Fragment, useState, useEffect } from 'react';
import classNames from 'classnames';
import { logger } from '@lmig/lmds-helpers/dist/logger';
import { Link } from '@lmig/lmds-react-link';
import { IconClose, IconButton } from '@lmig/lmds-react-icons';
import { Alert } from '@lmig/lmds-react-alert';
import "./notification.css";
var DISMISS_DURATION = 300;
var DISMISS_TIMEOUT;
// TODO: add prop table for Alert when needed
// @implements [AlertProps](https://designsystem.lmig.com/components/notifications/code#alert-props)
/**
 * @see [LMDS Notification documentation and examples](https://designsystem.lmig.com/components/notifications/code)
 *
 * API:
 *
 * @implements [NotificationsProps](https://designsystem.lmig.com/components/notifications/code#notification-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var Notification = function Notification(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$highlightType = _ref.highlightType,
    highlightType = _ref$highlightType === void 0 ? 'neutral' : _ref$highlightType,
    alert = _ref.alert,
    links = _ref.links,
    icon = _ref.icon,
    _ref$isDismissed = _ref.isDismissed,
    isDismissedProp = _ref$isDismissed === void 0 ? false : _ref$isDismissed,
    _ref$isDismissible = _ref.isDismissible,
    isDismissible = _ref$isDismissible === void 0 ? false : _ref$isDismissible,
    onDismiss = _ref.onDismiss,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    children = _ref.children,
    nativeProps = _objectWithoutProperties(_ref, _excluded);
  if (links && links.length > 2) {
    logger.warn('Notification: Per design guidelines, the `links` prop should not contain more than 2 links.');
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDismissing = _useState2[0],
    setIsDismissing = _useState2[1];
  var _useState3 = useState(isDismissedProp),
    _useState4 = _slicedToArray(_useState3, 2),
    isDismissed = _useState4[0],
    setIsDismissed = _useState4[1];
  var handleDismiss = function handleDismiss(e) {
    if (typeof onDismiss === 'function' && !!e) {
      onDismiss(e);
    }
    setIsDismissing(true);
    DISMISS_TIMEOUT = setTimeout(function () {
      setIsDismissed(true);
      setIsDismissing(false);
    }, DISMISS_DURATION);
  };
  useEffect(function () {
    if (isDismissedProp) {
      handleDismiss();
    } else {
      setIsDismissed(false);
      setIsDismissing(false);
    }
    return function () {
      return clearTimeout(DISMISS_TIMEOUT);
    };
  }, [isDismissedProp]);
  var renderDismissButton = function renderDismissButton() {
    if (isDismissible) {
      return /*#__PURE__*/React.createElement(IconButton, {
        initialSize: "16",
        background: "transparent",
        className: "lmig-Notification-dismissButton",
        onClick: handleDismiss
      }, /*#__PURE__*/React.createElement(IconClose, {
        size: "16",
        className: "lmig-Notification-dismissButton-iconClose",
        title: "Close this notification"
      }));
    }
    return null;
  };
  var renderLinks = function renderLinks() {
    var filteredLinks = links.filter(function (link) {
      return !!link;
    }).map(function (link, ix) {
      var linkElement;
      // We can't use the href as a key if someone passes multiple '#' so fall back to the index.
      var uniqueKey = link.href && link.href.length > 1 ? link.href.replace('#', '') : "link".concat(ix);
      // "lmig-Link" is included for compatibility with apps that may rely on the class name from Link 0.x. Link 1.x uses "lm-link" instead.
      // Link 2.x may switch back to lmig-Link.
      if ( /*#__PURE__*/React.isValidElement(link) && link.type === Link) {
        linkElement = /*#__PURE__*/React.createElement(Fragment, {
          key: uniqueKey
        }, link);
      } else if (link.children) {
        linkElement = /*#__PURE__*/React.createElement(Link, _extends({
          className: "lmig-Link"
        }, link, {
          key: uniqueKey
        }));
      }
      return linkElement;
    });
    return filteredLinks.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "lmig-Notification-links"
    }, filteredLinks);
  };
  var getClassNames = classNames('lmig-Notification', "lmig-Notification--".concat(highlightType), {
    'lmig-Notification--isDismissing': isDismissing
  }, {
    'lmig-Notification--hasDismissButton': isDismissible
  }, {
    'lmig-Notification--inline': inline
  }, className);
  return !isDismissed && /*#__PURE__*/React.createElement("div", _extends({
    id: id
  }, nativeProps, {
    role: isDismissible ? 'alertdialog' : 'alert',
    className: getClassNames
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('lmig-Notification-content', {
      'lmig-Notification-content--noMainContent': !alert
    })
  }, (alert || highlightType) && /*#__PURE__*/React.createElement(Alert, {
    className: "lmig-Notification-mainContent",
    highlightType: highlightType,
    icon: icon
  }, alert), children && /*#__PURE__*/React.createElement("div", {
    className: "lmig-Notification-supportingContent"
  }, children)), links && renderLinks(), renderDismissButton());
};
Notification.propTypes = {
  /** Add an optional ID to this element: `<div class="lmig-Notification">`. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lmig-Notification">`. */className: _pt.string,
  /**
     * Set the highlight type which applies a color treatment and renders a default icon.
     * @default 'neutral'
     */
  highlightType: _pt.oneOf(['neutral', 'informative', 'negative', 'positive', 'caution']),
  /**
     * Set the notification main content.
     */
  alert: _pt.node,
  /**
     * Replace the default icon.
     */
  icon: _pt.node,
  /**
     * Provide up to 2 links. This prop can accept an array of Links or an array of Link prop objects.
     */
  links: _pt.array,
  /**
     * Render a dismiss button which allow the user to remove this notification from the page.
     * @default false
     */
  isDismissible: _pt.bool,
  /**
     * Dismiss this notification and trigger dismissal animation.
     * @default false
     */
  isDismissed: _pt.bool,
  /**
     * Render all children inline.
     * @default false
     */
  inline: _pt.bool,
  /**
     * Provide a callback to get access to the event when the dismiss button is clicked.
     */
  onDismiss: _pt.func,
  /**
     * Set the notification supporting content. Rendered inside this element: `<div class="lmig-Notification-supportingContent">`.
     */
  children: _pt.node
};